export default {
    categoryAmbiences:      { method: 'get',    url: 'category_ambiences' },
    createCategoryAmbience: { method: 'post',   url: 'category_ambiences'},
    updateCategoryAmbience: { method: 'put',    url: 'category_ambiences/{id}'},
    deleteCategoryAmbience: { method: 'delete', url: 'category_ambiences/{id}'}
}